import getStripePromise from "../../API/ApiEndPoints/loadStripe";
import {Elements, PaymentElement, useElements, useStripe} from "@stripe/react-stripe-js";
import React from "react";
import {useSession} from "../../redux/Reducers/AuthReducer";
import {useNavigate} from "react-router-dom";
import {CURRENCY} from "../../settings/settings";
import FormButton from "../../components/Form/Button/FormButton";


function BuyCard({className, selectedPackage, setIsOpen, onSucess, client_secret, ...props}) {
    const [error, setError] = React.useState(null);
    const elements = useElements();
    const stripe = useStripe();
    const [isLoading, setIsLoading] = React.useState(false);
    const handleChange = (event) => {
        if (event.error) {
            setError(event.error.message);
        } else {
            setError(null);
        }
    }

    const handleSubmit = async (event) => {
        event.preventDefault();

        const {error: submitError} = await elements.submit();
        if (submitError) {
            // Show error to your customer
            setError(submitError.message);
            return;
        }

        setIsLoading(true)


        const {error} = await stripe.confirmPayment({
            elements: elements,
            clientSecret: client_secret,
            confirmParams: {
                return_url: `${window.location.origin}/bought-package/${selectedPackage?.coupon_id}/${selectedPackage?.user_email}`
            }
        });
        setIsLoading(false)
        if (error) {
            setError(error.message);

        } else {
            if (onSucess)
                onSucess(true)


        }

    }
    return (<form onSubmit={handleSubmit} className={"flex flex-col  gap-[20px] py-[30px] justify-center items-center"}>
        <img src={"/logo.png"} className={"w-[200px]"} alt={"logo"}/>

        <p>
            <span className={"font-bold"}>{CURRENCY}{selectedPackage?.price}{" "}</span>
            will be charged from your card
        </p>
        <div className={"w-full flex flex-col gap-2"}>
            <PaymentElement id="card-element" className={""} onChange={handleChange}/>
            {error && <ul className={"px-6 list-disc text-red-500"}>
                <li>
                    {error}
                </li>
            </ul>}
        </div>
        <FormButton
            loading={isLoading}
            showLoadingOnLeft={true}
            disabled={!stripe || !elements}
            type={"submit"}
        >
            Pay {CURRENCY}{selectedPackage?.price} for DET Coupon Code
        </FormButton>
    </form>)
}

export default function CreateCouponPayment({className, onSucess, paymentIntent, setOpen, ...props}) {
    const stripePromise = getStripePromise()
    const client_secret = paymentIntent?.client_secret

    const options = {
        // passing the client secret obtained from the server
        appearance: {
            theme: 'stripe',
        },
        clientSecret: client_secret

    };
    return (
        <div className={` ${className}`}>
            <Elements stripe={stripePromise}
                      options={options}
            >
                <BuyCard
                    client_secret={client_secret}
                    selectedPackage={paymentIntent}
                    onSucess={onSucess}
                    setIsOpen={setOpen}/>
            </Elements>
        </div>

    )
}